import type { ConversionErrorReason } from '@/types/conversion'

export const MAPPED_MSC_ERRORS_TRANSLATIONS = {
  'rateExceeded': 'pdfextra_convert_tool.errors.msc.rate_exceeded',
  'unsupportedFormatConversion': 'pdfextra_convert_tool.errors.msc.unsupported_format_conversion',
  'internalConverterError': 'pdfextra_convert_tool.errors.msc.internal_converter_error',
  'unknown': 'pdfextra_convert_tool.errors.msc.unknown'
}

export function getServiceErrorTranslation(error: ConversionErrorReason): string {
  return MAPPED_MSC_ERRORS_TRANSLATIONS[error]
}
